import React from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {LookAugmentRealityIcon} from "../../../../common/icons";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";
import Button from "@mui/material/Button";

const ARViewUSDZButton = (props) => {
  const {url} = props;

  const makeImage = () => {
    const c = document.createElement('canvas');
    const i = new Image();
    i.src = c.toDataURL();

    return i;
  }

  const makeLink = (url) => {
    return Object.assign(document.createElement('a'), {
      download: 'asset.usdz',
      rel: "ar",
      href: url
    });
  }

  const arClick = () => {
    const i = makeImage();
    const a = makeLink(url);
    a.appendChild(i);
    a.click();
  }

  return (
    <Button className="ar-popup__link"
                onClick={arClick}>
      <SvgIcon>
        <LookAugmentRealityIcon/>
      </SvgIcon>
      <div>
        <b>AUGMENTED</b> REALITY
      </div>
      <div>
        <small>TAP TO ACTIVATE</small>
      </div>
    </Button>
  )
};

ARViewUSDZButton.propTypes = {
  url: PropTypes.string,
};

const mapStateToProps = (store) => {
  return {
    visualizersLoaded: store.serverState.visualizersLoaded,
    cabinetsARBlobUrl: store.sqftState.cabinetsARBlobUrl,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(ARViewUSDZButton)
  )
);
